import styled from 'styled-components';
import { buttonResetStyles } from '../header.styles';

export const HeaderWrapper = styled.div`
  background: var(--dcm-header-bg);
  border-bottom: var(--dcm-header-border-width) solid var(--dcm-header-border-color);
  color: var(--dcm-header-text-color);
  padding: var(--dcm-header-mobile-padding-x);
`;

export const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  gap: var(--dcm-header-gap);
  justify-content: space-between;
  position: relative;
  width: 100%;
`;

export const UtilityNav = styled.div`
  align-items: center;
  display: flex;
  gap: var(--dcm-header-gap);
  position: relative;
`;

export const MenuButton = styled.button`
  ${buttonResetStyles}
  align-self: stretch;
  align-items: center;
  color: currentColor;
  display: flex;
  font-weight: var(--dcm-header-mobile-menu-btn-font-weight);
  line-height: ${24 / 16};
  gap: var(--dcm-space-2);
`;
